// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header__Pw4XH","header__title":"Header__header__title__1699c","header__secondary":"Header__header__secondary__1lg4r"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Header/Header.css
// module id = 20
// module chunks = 0